
import { SetupContext, reactive, computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import FavoriteButton from '@/components/elements/FavoriteButton.vue'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'
import HospitalTag from '@/components/elements/HospitalTag.vue'
import HospitalDetailGraph from '@/components/block/HospitalDetailGraph.vue'
import { numberFormatAddComma } from '@/utils/commonMethods'
import { ActionHistory } from '@/types/StoreState'

export default defineComponent({
  name: 'HospitalCassette',

  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    column2: {
      type: Boolean,
      default: false
    },
    enableRequest: {
      type: Boolean,
      default: false
    },
    isShowFeatures: {
      type: Boolean,
      default: true
    },
    isShowRequestBtn: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Button,
    FavoriteButton,
    HospitalLabel,
    HospitalTag,
    HospitalDetailGraph
  },

  setup(props, context: SetupContext) {
    const store = useStore()
    const data = reactive({
      bedNum: props.detail.bed_num
        ? numberFormatAddComma(props.detail.bed_num) + '床'
        : '',
      doctorNum: props.detail.doctor_num
        ? numberFormatAddComma(props.detail.doctor_num) + '人'
        : '',
      features: props.detail.discerning_conditions
        ? props.detail.discerning_conditions.map((el: string) => {
            return {
              label: el,
              disabled: false
            }
          })
        : [],
      graphData: [
        {
          label: '症例数',
          rate: props.detail.cases_num
        },
        {
          label: '指導医数',
          rate: props.detail.instructors_num
        },
        {
          label: '給与',
          rate: props.detail.salary
        },
        {
          label: '倍率',
          rate: props.detail.magnification
        }
      ]
    })

    const labels = computed(() => {
      const res = []
      if (props.detail?.prefectures) res.push(props.detail.prefectures)
      if (props.detail?.junior > 0) res.push('初期研修')
      if (props.detail?.specialist > 0) res.push('専門研修')
      return res
    })

    const isShowScore = computed(() =>
      data.graphData.some((data: { label: string; rate: number }) => data.rate)
    )

    // お気に入りに追加済みの病院の場合お気に入り済みに変更
    const isFavorite = computed(() => {
      if (!store.state.isLogin) return false

      return store.state.userInfo.favorite_history.some(
        (el: ActionHistory) => el.hospital_id == props.detail.hospital_id
      )
    })

    const favBtnLabel = computed(() =>
      isFavorite.value ? 'お気に入り登録済み' : 'お気に入りに保存'
    )

    const clickFavBtn = () => {
      if (isFavorite.value) {
        store.dispatch('removeFavorite', { id: props.detail.hospital_id })
      } else {
        store.dispatch('addFavorite', { id: props.detail.hospital_id })
      }
    }

    const formattedPostperiodDt = computed(() => {
      if (!props.detail.postperiod_dt) return ''
      const dt = props.detail.postperiod_dt.split('/')
      return `${dt[0]}年${dt[1]}月${dt[2]}日まで`
    })

    const canRequestCheck = computed((): boolean => {
      return (
        props.enableRequest &&
        props.detail.paid_flg === 1 &&
        props.detail.active_flg === 3
      )
    })

    const isParticipateEvent = computed(() =>
      store.state.eventParticipatingHospitals.includes(
        String(props.detail.hospital_id)
      )
    )

    const changeInput = (e: any) => {
      context.emit('call-input-change', {
        value: e.target.value,
        checked: e.target.checked
      })
    }

    return {
      data,
      labels,
      isFavorite,
      isShowScore,
      clickFavBtn,
      favBtnLabel,
      canRequestCheck,
      formattedPostperiodDt,
      isParticipateEvent,
      changeInput
    }
  }
})
